import axios from "axios";

const _baseUrl = 'https://escolar.sophia.com.br/cep/WcfCepService.svc/restjson/'
const _key = '9A4A308CCC609267'

const pesquisarCep = async (cep) => {
    const data = await axios.get(`${_baseUrl}PesquisaCEP?senha=${_key}&quantidade=1&numeroCep=${cep}`)
    return data
}

export { pesquisarCep }